import * as ReactGA from "react-ga";

import { Dispatch, RootState, makeActionCreator } from "../../store/types";
import { Product, Category } from "../../models";

interface SearchParams {
  q?: string;
  category_id?: number;
  limit?: number;
}

export const SET_SEARCH_VAL = "prod-search/SET_SEARCH_VAL";
export const SET_SUGGESTIONS = "prod-search/SET_SUGGESTIONS";
export const SET_SUGGS_LOADING = "prod-search/SET_SUGGESTIONS_LOADING";
export const SET_SUGGS_VISIBILITY = "prod-search/SET_SUGGESTIONS_VISIBILITY";

export const setSearchVal = makeActionCreator<
  string
>(SET_SEARCH_VAL as typeof SET_SEARCH_VAL);
export const setSuggestionsVisiblity = makeActionCreator<
  boolean
>(SET_SUGGS_VISIBILITY as typeof SET_SUGGS_VISIBILITY);
export const setSuggestions = makeActionCreator<
  Product[]
>(SET_SUGGESTIONS as typeof SET_SUGGESTIONS);
const setSuggestionsLoading = makeActionCreator<
  boolean
>(SET_SUGGS_LOADING as typeof SET_SUGGS_LOADING);

// TODO: proper stateful error handling
export const searchProducts = (
  q?: string,
  limit = 10,
  category?: Category,
) => async (dispatch: Dispatch, getState: () => RootState, http) => {
  // Track search
  if (process.env.NODE_ENV === "production") {
    ReactGA.event({
      category: "landingpage",
      action: "Searched products",
      label: q,
    });
  }

  // Either search on category (all products, for now) or on query; hacky
  let params: SearchParams = { limit };
  if (category) {
    params.category_id = category.id;
  } else {
    params.q = q ? q.trim().replace(/\s+/g, " ") : "";
  }

  // Short circuit on empty query + no chosen category
  if (!q && !category) {
    dispatch(setSuggestionsVisiblity(false));
    return dispatch(setSuggestions([]));
  }

  dispatch(setSuggestionsVisiblity(true));
  dispatch(setSuggestionsLoading(true));

  try {
    const result: any = await http.get("data/products", { params });

    if (!result.products) {
      dispatch(setSuggestionsVisiblity(false)); // Don't show if no results
    }

    dispatch(setSuggestions(result.products || []));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setSuggestionsLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/actions.ts